export default {
  baseUrl: "https://naf-api.viserx.net/api",
  // "baseUrl": 'http://nafappapi.viserx.net/api',
  // baseUrl: "http://naf.test/api",
}; 


